// native
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

// service
import { CitationsEventService } from '../../../core/services/citations-event.service';

// model
import { ICitationSelection } from '../../../models';

@Component({
  selector: 'scs-citation-drawer',
  templateUrl: './citation-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CitationDrawerComponent implements OnInit, OnDestroy {

  isUpdate: boolean = false;

  citationSelectedSubscription: Subscription;

  constructor(
    public citationsEventService: CitationsEventService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.citationSelectedSubscription = this.citationsEventService.citationSelected$.subscribe((selection: ICitationSelection) => {
      this.isUpdate = !!selection?.items;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.citationSelectedSubscription?.unsubscribe();
  }

  onClick(): void {
    this.citationsEventService.addCitation(this.isUpdate);
  }
}
